module.exports = __webpack_public_path__ + "static/img/dadibanner1.31f6f34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadibanner1.jpg
// module id = 68Gt
// module chunks = 4